import React from 'react'
import { Divider } from '../../../components'

import {
  PhotoImage,
  StyledCarousel,
  StyledDiv,
  StyledItemsInputPhoto,
  StyledPhotoText,
  StyledRedText,
  StyledText,
  StyledUrlImage,
  Url,
} from '../styled'
import { ShowPhotosProps } from '../types'

export const ShowPhotos: React.FC<ShowPhotosProps> = ({
  items,
  setItems,
  setFixedItems,
  setDeleted,
  type,
}) => {

  const onPressDeleteFile = (file: any) => () => {
    if (!!file?.url) {
      setFixedItems((p: any) => [...p.filter((el: any) => el.id !== file.id)])

      setDeleted(prev => [...prev, file])
    }

    setItems((p: any) => [...p.filter((el: any) => el !== file)])
  }

  const fileHandler = (e: any) => {
    setItems((p: any) => [...p, ...e.target?.files])
  }

  return (
    <>
      <StyledText>{type}</StyledText>

      <Divider height={10} />

      {!!items?.length ? (
        <StyledCarousel>
          {items?.map((item: any, index: number) => {
            return (
              <React.Fragment
                key={(!!item.url ? item.url : item?.lastModified) + index}
              >
                <StyledDiv>
                  {type === 'Галерея' ? (
                    <StyledUrlImage href={item?.url} target="_blank">
                      <PhotoImage
                        src={
                          !!item?.url ? item?.url : URL.createObjectURL(item)
                        }
                      />
                    </StyledUrlImage>
                  ) : (
                    <Url href={item?.url} target="_blank">
                      {!!item?.name
                        ? item?.name
                        : item?.url
                            ?.split('/')
                            [item?.url.split('/').length - 1]?.split('?')[0]}
                    </Url>
                  )}

                  <Divider height={7} />

                  <StyledPhotoText onClick={onPressDeleteFile(item)}>
                    Удалить
                  </StyledPhotoText>
                </StyledDiv>
              </React.Fragment>
            )
          })}
        </StyledCarousel>
      ) : (
        <StyledRedText>Пусто</StyledRedText>
      )}

      <Divider height={10} />

      {type === 'Галерея' ? (
        <StyledItemsInputPhoto
          id="image"
          name="image"
          type="file"
          accept="image/*"
          onChange={fileHandler}
          multiple
        />
      ) : (
        <StyledItemsInputPhoto
          id="file"
          name="file"
          type="file"
          onChange={fileHandler}
          multiple
        />
      )}
    </>
  )
}
